import CustomAreaBlock from './CustomAreaBlock';

export default CustomAreaBlock;
